import React, { useEffect } from 'react';
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgSerbia_Zemun4 from '../../assets/management/Serbia_Zemun4.jpg';
import ContactBubble from '../../Components/ContactBubble/ContactBubble';
import imgTim from '../../assets/management/tim.jpg';

import imgHANSA_FLEX_Serbia_Managing_Director_Aleksandar_Pljevaljcic from '../../assets/management/HANSA_FLEX_Serbia_Managing_Director_Aleksandar_Pljevaljcic.webp'

function Management() {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    return (
        <div>
            <CenterStage title={"Meet our Management"} imageSrc={imgSerbia_Zemun4} paragraph={"At HANSA-FLEX, our management is influential in guiding the company with strategic vision and operational excellence. Through dynamic leadership and a focus on innovation, we prioritize customer satisfaction and sustainable growth. Our management fosters a culture of collaboration and empowerment, driving success across all facets of the organization."} />

            <div>
                <ContactBubble
                    imageSrc={imgHANSA_FLEX_Serbia_Managing_Director_Aleksandar_Pljevaljcic}
                    title="Aleksandar Pljevaljčić"
                    subTitle="Director"
                    description="Aleksandar Pljevaljčić, our influential Director, leads with strategic vision, fostering growth and innovation. With a wealth of experience, he drives excellence across our organization, ensuring success and customer satisfaction."
                />
                {/* description="Aleksandar Pljevaljčić, our Managing Director, is a visionary leader with over 23 years of experience in the industry. He excels in strategic planning and operational management, driving innovation and growth. His commitment to customer satisfaction and team empowerment has transformed our organization, making it a leader in the market." */}

                <ContactBubble
                    imageSrc={imgTim}
                    title="Tim Ollendorf"
                    subTitle="Director"
                    description="Tim Ollendorf, our Director, brings strategic vision and extensive industry expertise to HANSA-FLEX Serbia. His leadership drives innovation, operational excellence, and customer satisfaction, ensuring we remain a trusted partner for hydraulic solutions."
                />

                {/* Marianne Schmitt, our esteemed Operations Director, drives operational excellence with dedication and precision. With her leadership, we optimize processes, ensuring efficiency and delivering exceptional results to our valued customers. */}
            </div>
        </div>
    );
}

export default Management;